export default __webpack_public_path__ + "static/media/3.06585cd1.jpg";